export class AppException extends Error {
  constructor(message, statusCode) {
    super(message);
    this.name = "AppException";
    this.statusCode = statusCode;
  }
}

export class NotFoundException extends AppException {
  constructor(message = "The page you're looking for doesn't exist.") {
    super(message, 404);
    this.name = "NotFoundException";
  }
}

export class ForbiddenException extends AppException {
  constructor(message = "You don't have permission to access this page.") {
    super(message, 403);
    this.name = "ForbiddenException";
  }
}

export class UnauthorizedException extends AppException {
  constructor(message = "You must be logged in to view this page.") {
    super(message, 401);
    this.name = "UnauthorizedException";
  }
}

export class ServerException extends AppException {
  constructor(message = "Something went wrong on our end. Please try again later.") {
    super(message, 500);
    this.name = "ServerException";
  }
}

export class BadRequestException extends AppException {
  constructor(message = "The request was invalid or cannot be processed.") {
    super(message, 400);
    this.name = "BadRequestException";
  }
}
